import { useState } from "react";
import CheckIcon from "../icons/CheckIcon";
import PricingCard from "./PricingCard";

const businessPlan = [
  "20 videos (60-90 sec)",
  "Actors can hold your product",
  "90 seconds max video length",
  "100+ AI actors",
  "100+ AI voices",
  "Generated within minutes",
  "Bulk pick characters for split testing",
  "30+ different scenes & backgrounds",
  "Commercial usage rights",
  "24/7 Support",
];

const starterPlan = [
  "10 videos",
  "Actors can hold your product",
  "90 seconds max video length",
  "Bulk pick characters for split testing",
  "100+ actors and voices",
  "Commercial Usage Rights",
  "24/7 Support",
];

const growthPlan = [
  "",
  "Everything in Business +",
  "API Access (contact us)",
  "Add Team Members",
];

// Plan configuration that matches backend
const PLANS: {
  [key: string]: {
    name: string;
    features: string[];
    credits: number;
    monthlyPrice: number;
    primary?: boolean;
    priceId: string;
  };
} = {
  basic: {
    name: "Starter",
    features: starterPlan,
    credits: 10,
    monthlyPrice: 125,
    priceId: "price_1RHIQVE1A6TTIkJhytR6eJoo",
  },
  pro: {
    name: "Business",
    features: businessPlan,
    credits: 20,
    monthlyPrice: 165,
    primary: true,
    priceId: "price_1RGv2GE1A6TTIkJhUNgz3Ryg",
  },
  enterprise: {
    name: "Growth",
    features: growthPlan,
    credits: 40,
    monthlyPrice: 540,
    priceId: "price_1RHIP9E1A6TTIkJhBMxyFzSM",
  },
};

export default function jricingSection() {
  const [isAnnual, setIsAnnual] = useState(false);

  const lead = localStorage.getItem("lead") || "false";

  // Calculate annual price with 30% discount
  const calculateAnnualPrice = (monthlyPrice: number) => {
    return Math.round(monthlyPrice * 12 * 0.7);
  };

  // Calculate video credits based on billing cycle
  const calculateVideos = (baseCredits: number) => {
    return isAnnual ? baseCredits * 12 : baseCredits;
  };

  // Update feature list with correct video count based on billing cycle
  const updateFeatures = (features: string[], baseCredits: number) => {
    const videoCount = calculateVideos(baseCredits);
    const updatedFeatures = [...features];

    // Replace the first feature (video count) with updated count
    updatedFeatures[0] = `${videoCount} videos`;

    return updatedFeatures;
  };

  return (
    <section
      id="pricing"
      className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-950 transition-colors duration-200"
    >
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-4 transition-colors duration-200">
            Simple, scalable plans for every brand
          </h2>
          <p className="text-lg text-slate-600 dark:text-gray-300 max-w-3xl mx-auto transition-colors duration-200">
            Try it free with 10 short videos, then unlock full-length videos
            with our paid plans
          </p>
        </div>

        {/* Billing Toggle */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex p-1 bg-gray-100 dark:bg-gray-800 rounded-lg transition-colors duration-200">
            <button
              onClick={() => setIsAnnual(false)}
              className={`px-6 py-2 text-sm font-medium rounded-md transition-colors hover:cursor-pointer ${
                !isAnnual
                  ? "bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm"
                  : "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white"
              }`}
            >
              Monthly
            </button>
            <button
              onClick={() => setIsAnnual(true)}
              className={`px-6 py-2 text-sm font-medium rounded-md transition-colors hover:cursor-pointer ${
                isAnnual
                  ? "bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm"
                  : "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white"
              }`}
            >
              Annually{" "}
              <span className="text-green-500 dark:text-green-400 font-medium">
                (-30%)
              </span>
            </button>
          </div>
        </div>

        {/* <div className="text-center mb-12 bg-blue-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-blue-700 mb-2">
            Try Before You Buy
          </h3>
          <p className="text-slate-700">
            Sign up now to get 10 free 5-7 second sample videos to test our
            platform
          </p>
        </div> */}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Generate pricing cards from PLANS */}
          {Object.entries(PLANS).map(([planId, plan]) => (
            <PricingCard
              key={planId}
              planId={planId}
              priceId={plan.name}
              planName={plan.name}
              price={
                isAnnual
                  ? calculateAnnualPrice(plan.monthlyPrice)
                  : plan.monthlyPrice
              }
              description={`${calculateVideos(plan.credits)} videos included`}
              features={updateFeatures(plan.features, plan.credits)}
              primary={plan.primary || false}
              isAnnual={isAnnual}
              lead={lead}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
